var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusIconNarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eOBvYbG9UdS1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,4C0,1.79086,1.79086,0,4,0h26v30h-26c-2.20914,0-4-1.7909-4-4L0,4Z",
    transform: "matrix(0 1-1 0 30 0)",
    fill: "#66a49e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2476,14.0493c-2.8627,2.034-7.665,2.0385-10.49547.009l-.00225-3.183h10.50002l-.0023,3.174Zm.0023,4.9125h-1.8983v-.5265c0-.387.21-.7365.5363-.891l1.362-.6465v2.064Zm-8.6018,0h-1.89822v-2.0648l1.36272.6473c.3255.1545.5355.5047.5355.891v.5265Zm10.3965-8.0865h-1.0447v-.98999c0-.93225-.6923-1.635-1.6103-1.635h-8.7802c-.91727,0-1.60952.70275-1.60952,1.635v.98999h-1.0455c-.2505,0-.4545.2168-.4545.4845v1.9665c0,.7163.582,1.299,1.29825,1.299h.20175v5.5545c0,.006.00075.0105.00075.0158l.069,1.7992c.00975.2835.24075.5055.52425.5055h2.48622c.27,0,.4943-.2115.51-.477l.0705-1.023h4.6793l.0697,1.02c.0158.2685.24.48.51.48h2.4863c.2835,0,.5137-.222.5235-.5002l.0705-1.8203v-5.5545h.201c.717,0,1.299-.5827,1.299-1.299v-1.9665c0-.2677-.2048-.4845-.4553-.4845Z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusIconNarrow);
export default __webpack_public_path__ + "static/media/BusIconNarrow.730a12bbe3336f67311635c27a78e47f.svg";
export { ForwardRef as ReactComponent };